@import '../Field/field.css';
@import '../es-input/es-input.css';

::host {
    display: block;
}

.label {
    align-self: flex-start;
    padding-top: 15px;
}

.input {
    height: 120px;
    border-radius: 20px;
    border-bottom-right-radius: 0;
    resize: vertical;
    padding: 15px 20px;
}
